export const FilterIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.6667 13.3333C10.6667 13.7015 10.3682 14 10 14C9.63181 14 9.33333 13.7015 9.33333 13.3333L9.33333 8C9.33333 7.96232 9.33646 7.92537 9.34246 7.8894C8.5609 7.61744 8 6.87422 8 6C8 5.12578 8.5609 4.38256 9.34247 4.1106C9.33646 4.07463 9.33333 4.03768 9.33333 4L9.33333 2.66667C9.33333 2.29848 9.63181 2 10 2C10.3682 2 10.6667 2.29848 10.6667 2.66667L10.6667 4C10.6667 4.03768 10.6635 4.07463 10.6575 4.1106C11.4391 4.38256 12 5.12578 12 6C12 6.87422 11.4391 7.61744 10.6575 7.8894C10.6635 7.92537 10.6667 7.96232 10.6667 8L10.6667 13.3333Z"
			fill="#292424"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.33333 13.3333C5.33333 13.7015 5.63181 14 6 14C6.36819 14 6.66667 13.7015 6.66667 13.3333L6.66667 12.6667C6.66667 12.629 6.66354 12.592 6.65753 12.5561C7.4391 12.2841 8 11.5409 8 10.6667C8 9.79244 7.4391 9.04923 6.65753 8.77727C6.66354 8.7413 6.66667 8.70435 6.66667 8.66667L6.66667 2.66667C6.66667 2.29848 6.36819 2 6 2C5.63181 2 5.33333 2.29848 5.33333 2.66667L5.33333 8.66667C5.33333 8.70435 5.33646 8.7413 5.34247 8.77727C4.5609 9.04923 4 9.79244 4 10.6667C4 11.5409 4.5609 12.2841 5.34246 12.5561C5.33646 12.592 5.33333 12.629 5.33333 12.6667L5.33333 13.3333Z"
			fill="#292424"
		/>
	</svg>
)
